var map = {
	"./Dashboard.png": [
		40299,
		299
	],
	"./Data Analysis.png": [
		93159,
		159
	],
	"./Data Growth Statistics.png": [
		79810,
		810
	],
	"./Instructions.png": [
		89845,
		845
	],
	"./Presentation.png": [
		32681,
		681
	],
	"./Solar Panel.png": [
		17876,
		876
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98262;
module.exports = webpackAsyncContext;